export const bookingIdentifierMapper = (draftId) => {
  let dataObject = null
  if (draftId) {
    dataObject = { userId: draftId }
  }
  return dataObject
}
